import React, { ChangeEventHandler } from 'react'
import StyledText from '../../components/StyledComponents/StyledText'
import { useTheme } from '../../middleware/ThemeContext';
import styled from 'styled-components';
import { CheckCircle } from '@mui/icons-material';

interface ImgTextRadio {
    image?: string;
    title: string;
    text: string;
    name: string;
    value: string;
    isCheck: boolean;
    onClick: (field_key: string, value: string) => void;
    onChange: ChangeEventHandler<HTMLInputElement>;
    SetScope: () => void;
}

const ImgTextRadio: React.FC<ImgTextRadio> = ({ image, name, title, text, isCheck, onClick, value, SetScope, onChange }) => {
    const {theme} = useTheme();
  return (
    <RadioCon theme={theme} style={{ 
        borderColor: isCheck ? theme.CorporateTheme.colors.blueberry : theme.CorporateTheme.colors.border,
        backgroundColor: isCheck ? theme.CorporateTheme.colors.primaryLightBG : 'transparent',
     }}
     onClick={() => {onClick(name, value); SetScope()}}
     >
        {image &&
            <img src={image} alt={title} style={{ width: '67px', height: '67px' }} />
        }
        <div style={{ padding: '0px 10px' }}>
            <StyledText fontSize='14px' fontWeight={600} style={{ lineHeight: '20px', marginBottom: '3px' }}>
                {title}
            </StyledText>
            <StyledText 
                fontSize='12px' 
                fontWeight={400} 
                textColor={theme.CorporateTheme.colors.textSecondary} 
                style={{ lineHeight: '16px' }}
            >
                {text}
            </StyledText>
        </div>
        <div>
            <CheckCircle fontSize='small' htmlColor={isCheck ? theme.CorporateTheme.colors.primary : theme.CorporateTheme.colors.border} />
            <input 
                type='radio' 
                name={name} 
                // value={item.id} 
                checked={isCheck ? true : false} 
                onChange={onChange} 
                style={{ display: 'none' }}
            />
        </div>
    </RadioCon>
  )
}

const RadioCon = styled.div`
    border: 1px solid;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
`;

export default ImgTextRadio